import Vue  from 'vue';
import VueRouter from 'vue-router';

const Login = () => import(/* webpackChunkName: "login" */ '../pages/Login/Login');
const Home = () => import('../pages/Home/Home');
// import Msite from '../pages/Msite/Msite';
const Msite = () => import('../pages/Msite/Msite');
const Enterprise = () => import('../pages/Enterprise/Enterprise');
const Base = () => import('../pages/Base/Base');

const AddBase = () => import('../pages/Base/AddBase/AddBase');

const EditBase = () => import('../pages/Base/EditBase/EditBase');

const Production = () => import('../pages/Production/Production');

const AddProduction = () => import('../pages/Production/AddProduction/AddProduction');

const EditProduction = () => import('../pages/Production/EditProduction/EditProduction');

const Manufacture = () => import('../pages/Manufacture/Manufacture');

const AddManufacture = () => import('../pages/Manufacture/AddManufacture/AddManufacture');

const EditManufacture = () => import('../pages/Manufacture/EditManufacture/EditManufacture');

const Code = () => import('../pages/Code/Code');

const AddCode = () => import('../pages/Code/AddCode/AddCode');

const DetailCode = () => import('../pages/Code/DetailCode/DetailCode');

const TraceTemplate = () => import('../pages/TraceTemplate/TraceTemplate');

const AddTraceTemplate = () => import('../pages/TraceTemplate/AddTraceTemplate/AddTraceTemplate');

const DetailTraceTemplate = () => import('../pages/TraceTemplate/DetailTraceTemplate/DetailTraceTemplate');

const Certification = () => import('../pages/Certification/Certification');

const Help = () => import('../pages/Help/Help');

const EnterpriseHelp = () => import('../pages/Help/EnterpriseHelp/EnterpriseHelp');

const BaseHelp = () => import('../pages/Help/BaseHelp/BaseHelp');

const HomeHelp = () => import('../pages/Help/HomeHelp/HomeHelp');

const ManufactureHelp = () => import('../pages/Help/ManufactureHelp/ManufactureHelp');

const ProductionHelp = () => import('../pages/Help/ProductionHelp/ProductionHelp');

const Users = () => import('../pages/Users/Users');

const AddUsers = () => import('../pages/Users/AddUsers/AddUsers');

const EditUsers = () => import('../pages/Users/EditUsers/EditUsers');

const AssignUserRole = () => import('../pages/Users/AssignUserRole/AssignUserRole');

const Roles = () => import('../pages/Roles/Roles');

const AddRoles = () => import('../pages/Roles/AddRoles/AddRoles');

const EditRoles = () => import('../pages/Roles/EditRoles/EditRoles');

const AssignRoleRight = () => import('../pages/Roles/AssignRoleRight/AssignRoleRight');

const QA = () => import('../pages/QA/QA');

const DetailQA = () => import('../pages/QA/DetailQA/DetailQA');

const Question = () => import('../pages/QA/Question/Question');

import {localCache} from '../utils/utils';

// 声明使用插件
Vue.use(VueRouter);
// 向外暴露路由器对象
const router = new VueRouter({
    // 配置n个路由
    routes:[
        {
            path: "/login",
            component: Login
        },
        {   // 自动跳转路由
            path: "/",
            redirect: "/login"
        },
        {
            path: "/home",
            component: Home,
            redirect: "/getHome",
            children: [
                {
                    path: "/getHome",
                    component: Msite,
                },
                {
                    path: "/enterprise/update",
                    component: Enterprise,
                },
                // 基地
                {
                    path: "/base/query",
                    component: Base,
                    meta: {title: "基地信息", keepAlive: true},
                },
                // 新增基地
                {
                    path: "/addBase",
                    component: AddBase,
                    meta: {title: "新增基地信息", GuidePath: true, JumpPath: "/base/query"},
                },
                // 编辑基地
                {
                    path: "/editBase",
                    component: EditBase,
                    meta: {title: "编辑基地信息", GuidePath: true, JumpPath: "/base/query"},
                },
                // 生产
                {
                    path: "/production/query",
                    component: Production,
                    meta: {title: "生产信息", keepAlive: true},
                },
                // 新增生产
                {
                    path: "/addProduction",
                    component: AddProduction,
                    meta: {title: "新增生产信息", GuidePath: true, JumpPath: "/production/query"},
                },
                // 编辑生产
                {
                    path: "/editProduction",
                    component: EditProduction,
                    name: "production",
                    meta: {title: "编辑生产信息", GuidePath: true, JumpPath: "/production/query"},
                },
                // 加工
                {
                    path: "/manufacture/query",
                    component: Manufacture,
                    meta: {title: "加工信息", keepAlive: true},
                },
                // 新增加工
                {
                    path: "/addManufacture",
                    component: AddManufacture,
                    meta: {title: "新增加工信息", GuidePath: true, JumpPath: "/manufacture/query"},
                },
                // 编辑加工
                {
                    path: "/editManufacture",
                    component: EditManufacture,
                    meta: {title: "编辑加工信息", GuidePath: true, JumpPath: "/manufacture/query"},
                },
                // 追溯码
                {
                    path: "/code/query",
                    component: Code,
                    meta: {title: "追溯码", keepAlive: true},
                },
                // 新增追溯码
                {
                    path: "/addCode",
                    component: AddCode,
                    meta: {title: "新增追溯码信息", GuidePath: true, JumpPath: "/code/query"},
                },
                // 追溯码详情
                {
                    path: "/detailCode",
                    component: DetailCode,
                    meta: {title: "追溯码详情", GuidePath: true, JumpPath: "/code/query"},
                },
                // 追溯模板
                {
                    path: "/template/query",
                    component: TraceTemplate,
                    meta: {title: "追溯模板", keepAlive: true},
                },
                // 新增追溯模板
                {
                    path: "/addTraceTemplate",
                    component: AddTraceTemplate,
                    meta: {title: "新增追溯模板信息", GuidePath: true, JumpPath: "/template/query"},
                },
                // 追溯模板详情
                {
                    path: "/detailTraceTemplate",
                    component: DetailTraceTemplate,
                    meta: {title: "追溯模板详情", GuidePath: true, JumpPath: "/template/query"},
                },
                // 资质证书
                {
                    path: "/certification/update",
                    component: Certification,
                },
                // 用户管理
                {
                    path: "/sys/user/query",
                    component: Users,
                    meta: {title: "用户管理", keepAlive: true},
                },
                // 新增用户管理
                {
                    path: "/addUsers",
                    component: AddUsers,
                    meta: {title: "新增用户管理", GuidePath: true, JumpPath: "/sys/user/query"},
                },
                // 编辑用户管理
                {
                    path: "/editUsers",
                    component: EditUsers,
                    meta: {title: "编辑用户管理", GuidePath: true, JumpPath: "/sys/user/query"},
                },
                // 分配角色
                {
                    path: "/assignUserRole",
                    component: AssignUserRole,
                    meta: {title: "分配角色", GuidePath: true, JumpPath: "/sys/user/query"},
                },
                // 角色管理
                {
                    path: "/sys/role/query",
                    component: Roles,
                    meta: {title: "角色管理", keepAlive: true},
                },
                // 新增角色管理
                {
                    path: "/addRoles",
                    component: AddRoles,
                    meta: {title: "新增角色管理", GuidePath: true, JumpPath: "/sys/role/query"},
                },
                // 编辑角色管理
                {
                    path: "/editRoles",
                    component: EditRoles,
                    meta: {title: "编辑角色管理", GuidePath: true, JumpPath: "/sys/role/query"},
                },
                // 角色授权
                {
                    path: "/assignRoleRight",
                    component: AssignRoleRight,
                    meta: {title: "角色授权", GuidePath: true, JumpPath: "/sys/role/query"},
                },
                // QA 管理
                {
                    path: "/qa/query",
                    component: QA,
                    meta: {title: "QA管理", keepAlive: true},
                },
                // 我要问
                {
                    path: "/question",
                    component: Question,
                    meta: {title: "我要问", GuidePath: true, JumpPath: "/qa/query"},
                },
                // 详情
                {
                    path: "/detailQa",
                    component: DetailQA,
                    meta: {title: "QA详情", GuidePath: true, JumpPath: "/qa/query"},
                },
            ]
        },
        {
            path: "/help",
            component: Help,
            redirect: "/homeHelp",
            children: [
                {
                    path: "/homeHelp",
                    component: HomeHelp,
                },
                {
                    path: "/help/enterpriseHelp",
                    component: EnterpriseHelp,
                },
                {
                    path: "/help/baseHelp",
                    component: BaseHelp,
                },
                {
                    path: "/help/manufactureHelp",
                    component: ManufactureHelp,
                },
                {
                    path: "/help/productionHelp",
                    component: ProductionHelp,
                },
            ]
        },
    ]
})
// 挂载路由导航守卫
router.beforeEach((to, from, next) => {
    // to 将要访问的路径
    // from 代表从哪个路径跳转而来
    // next 是一个函数，表示放行
    //     next()  放行    next('/login')  强制跳转

    if (to.path === '/login') return next();
    // 获取token
    const tokenStr = localCache.get("token");
    // const tokenStr = window.sessionStorage.getItem('token');
    if (!tokenStr) return next('/login');
    next();
})

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js